import { Hidden, IconButton, useMediaQuery } from "@material-ui/core";
import React from "react";
import { Link, useHistory } from "react-router-dom";

import { ReactComponent as CloseIcon } from "assets/close.svg";
import { ReactComponent as BrainImage } from "assets/brain-magnify.svg";
import { StyledGrid, StyledP } from "components/simple";
import {
  breakpoints,
  color,
  fontFamily,
  fontSize,
  iconSizes,
  spacingDefaults
} from "style/constants";
import routesConfig from "utils/routesConfig";

interface SurveyBannerProps {
  dismiss(): Promise<void>;
  firstName?: string;
}

const SurveyBanner: React.FC<SurveyBannerProps> = ({
  dismiss,
  firstName
}: SurveyBannerProps) => {
  const mobile = useMediaQuery(`(max-width:${breakpoints.lg}px)`);
  const history = useHistory();

  return (
    <StyledGrid
      alignItems="center"
      backgroundColor={color.WHITE}
      borderRadius="8px"
      container
      overflow={mobile ? "hidden" : undefined}
      padding="20px"
      position="relative"
      onClick={
        mobile
          ? () => history.push(routesConfig.surveys.survey.path)
          : undefined
      }
    >
      <Hidden mdDown>
        <StyledGrid item height="50px" position="relative">
          <BrainImage
            height={350}
            style={{
              position: "absolute",
              top: "-145px"
            }}
            width={220}
          />
        </StyledGrid>

        <StyledGrid container direction="column" item marginLeft="260px" xs>
          <StyledGrid item marginBottom={spacingDefaults.xsmall}>
            <StyledP
              color={color.BLACK}
              fontFamily={fontFamily.secondary}
              fontSize={fontSize.large}
              aria-label="learn"
            >
              {firstName}, we need <strong>YOU</strong> to help us learn more
              about the brain
            </StyledP>
          </StyledGrid>

          <StyledP color={color.BLACK} aria-label="discovery">
            Answer a few questions and impact scientific discovery.
          </StyledP>

          <Link to={routesConfig.surveys.survey.path} aria-label="go-to-survey">
            <StyledP color={color.BLACK} margintop={spacingDefaults.small}>
              <strong>Take Survey (2 min) &gt;</strong>
            </StyledP>
          </Link>
        </StyledGrid>
      </Hidden>
      <Hidden lgUp>
        <StyledGrid item height="0px" position="relative" width="60px">
          <BrainImage
            height={140}
            style={{
              left: "-25px",
              position: "absolute",
              top: "-20px"
            }}
            width={100}
          />
        </StyledGrid>

        <StyledGrid container direction="column" item marginLeft="85px">
          <StyledP
            color={color.BLACK}
            fontSize={fontSize.medium}
            aria-label="learn-mobile"
          >
            {firstName}, we need <strong>YOU</strong> to help us learn more
            about the brain
          </StyledP>

          <StyledP color={color.BLACK} aria-label="go-to-survey-mobile">
            <strong>Take Survey (2 min) &gt;</strong>
          </StyledP>
        </StyledGrid>
      </Hidden>

      <StyledGrid item position="absolute" right="5px" top="5px">
        <IconButton
          aria-label="close-notification"
          onClick={event => {
            event.stopPropagation();
            dismiss();
          }}
        >
          <CloseIcon
            stroke={color.WHITE}
            height={iconSizes.smaller}
            width={iconSizes.smaller}
          />
        </IconButton>
      </StyledGrid>
    </StyledGrid>
  );
};

export default SurveyBanner;
